import React from 'react';
import PropTypes from 'prop-types';

const VehicleDisplay = ({ vehicle, showVin }) => {
	return (
		<React.Fragment>
			{`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
			{showVin && vehicle.vin && ` VIN: ${vehicle.vin}`}
		</React.Fragment>
	);
};

VehicleDisplay.propTypes = {
	vehicle: PropTypes.object.isRequired,
	showVin: PropTypes.bool,
};

export default VehicleDisplay;
